import Button from './Button';
import Modal from './Modal';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import Text from './Text';

type Props = {
  title: string;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
};

export default function ConfirmDeleteModal({
  title,
  message,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Modal size="confirm" onClose={onClose}>
      <ModalBody size="confirm">
        <Text typeface="headline" color="neutral100" as="h2">
          {title}
        </Text>
        <Text typeface="body.small.regular" color="neutral60">
          {message}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          label="Cancel"
          variant="text"
          colorScheme="black"
          onClick={onClose}
        />
        <Button label="Confirm Delete" onClick={onConfirm} />
      </ModalFooter>
    </Modal>
  );
}
